/* TMAC header: SHOP ALL sits first inside PANTS & SHORTS (or SHOP); store details at the foot of the phone menu.
   Gecko loads dropdown contents lazily, so this watches for them and adds the link when they appear. */
(function(){
  var ALL_URL = '/collections/shop-all';
  var HOSTS = ['PANTS & SHORTS', 'PANTS AND SHORTS', 'SHOP'];
  function isShop(a){ return a && HOSTS.indexOf(a.textContent.replace(/\s+/g,' ').trim().toUpperCase()) > -1; }

  /* sub = the dropdown container; its rows are <li> (phone) or div.t4s-menu-item (desktop) */
  function addAll(sub){
    if (!sub || sub.querySelector('.tmh-all')) return;
    var firstLink = sub.querySelector('a[href]');
    if (!firstLink) return;
    var first = firstLink.closest('li, .t4s-menu-item');
    if (!first || !sub.contains(first)) return;
    var row = first.cloneNode(true);
    row.classList.add('tmh-all');
    var a = row.querySelector('a[href]');
    a.setAttribute('href', ALL_URL);
    var label = a.querySelector('span') || a;
    label.textContent = 'SHOP ALL';
    row.querySelectorAll('ul, .t4s-sub-menu').forEach(function(n){ n.remove(); });
    first.parentNode.insertBefore(row, first);
  }

  function desktop(){
    document.querySelectorAll('.t4s-section-header .t4s-nav__ul > li.has--children').forEach(function(li){
      var a = li.querySelector(':scope > a');
      if (!isShop(a)) return;
      var href = (a.getAttribute('href') || '').trim();
      if (href === '/' || href === '' || href === '#') a.setAttribute('href', ALL_URL);
      addAll(li.querySelector('.t4s-sub-menu'));
    });
  }

  function mobile(){
    var d = document.getElementById('t4s-menu-drawer');
    if (!d) return;
    d.querySelectorAll('.t4s-mb__menu > li').forEach(function(li){
      var a = li.querySelector('a');
      if (!isShop(a)) return;
      addAll(li.querySelector('.t4s-sub-menu'));
    });
    var tab = d.querySelector('.t4s-mb-tab__content');
    if (tab && !d.querySelector('.tmh-store')) {
      var box = document.createElement('div');
      box.className = 'tmh-store';
      box.innerHTML = '<strong>Visit our store</strong>TMAC GH<br>2/F Shoppesville, GH Mall<br>San Juan City<br><br>Mon to Thu: 11:00 AM to 9:00 PM<br>Fri to Sun: 10:00 AM to 10:00 PM';
      tab.appendChild(box);
    }
  }

  function run(){ pending = 0; try { desktop(); } catch(e){} try { mobile(); } catch(e){} }
  var pending = 0;
  function schedule(){ if (!pending) pending = setTimeout(run, 40); }

  function boot(){
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
})();